// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"terminal-window"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 20L22 20L22 9L2 9L2 20Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M2 9L22 9L22 4L2 4L2 9Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 9H22M2 9L2 4L22 4V9M2 9L2 20H22V9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6 16L6 13","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TerminalWindowIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'terminal-window',
    ref,
    icon: element,
  },
));

TerminalWindowIcon.displayName = 'TerminalWindowIcon';

export default TerminalWindowIcon;
